<template>
  <div>
    <q-field error-label="Invalid Date">
      <q-search v-model="filter" :placeholder="placeholder" v-if="!hide">
        <q-autocomplete 
          ref="ClassAutoComplete"
          :debounce="500"
          :max-results="maxResults"
          @search="onSearch"
          @selected="onSelect"
        />
      </q-search>
    </q-field>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'ClassAutoComplete',
  props: ['onSelect', 'hide'],
  data () {
    return {
      filter: null,
      placeholder: 'Start typing a name or email',
      maxResults: 5
    }
  },
  computed: {
    ...mapGetters('classes', [
      'autoCompleteOptions'
    ])
  },
  methods: {
    ...mapActions('classes', [
      'fetchAutoComplete'
    ]),
    onSearch (s, done) {
      this.fetchAutoComplete({ s })
      setTimeout(() => {
        done(this.autoCompleteOptions)
      }, 1000)
    }
  }
}
</script>

<style>
</style>
